import {
  DotLottieReact as ImportedDotLottieReact,
  type DotLottieReactProps,
  setWasmUrl,
} from '@lottiefiles/dotlottie-react'

setWasmUrl('/lottie-wasm/dotlottie-player.wasm')

export const DotLottieReact = (props: DotLottieReactProps) => {
  return <ImportedDotLottieReact {...props} />
}
